// zhaoqing 2019-9-3

'use strict';
angular.module('createTerritoryPointModule', ['tManageMentServiceModule'])
    .controller('territoryPointCreateCtrl', ['$scope', '$modalInstance', '$q', 'trsHttpService', 'item', 'modalDialog', '$validation', function($scope, $modalInstance, $q, trsHttpService, item, modalDialog, $validation) {
        initStatus();
        initData();

        /** [initStatus description]初始化状态 */
        function initStatus() {
            $scope.status = {
                serviceTitlt: '新建',
                detail: false
            };
            $scope.data = {
                dictName: '', 
                dictNum: '', 
                orderNum: '',
                description: '',
                fieldId: ''
            };
        }

        /** [initData description] 初始化数据 */
        function initData() {
            if (!item.item) {
                $scope.status.serviceTitlt = '新建';
            } else {
                if (item.isDetail) {
                    $scope.status.serviceTitlt = '详情';
                    $scope.status.detail = true;
                } else {
                    $scope.status.serviceTitlt = '编辑';
                    $scope.data.fieldId = item.item.fieldId;
                }
                $scope.data.dictName = item.item.dictName;
                $scope.data.dictNum = item.item.dictNum;
                $scope.data.orderNum = item.item.orderNum;
                $scope.data.description = item.item.description;
            }
        }

        /** [funciton description]确定按钮执行的操作 */
        $scope.confirm = function() {
            console.log($scope.data);
            $validation.validate($scope.createTeerritoryPoint).success(function() {
                if (item.item === undefined) {
                    detection().then(createHandler);
                } else {
                    detection().then(editHandler);
                }
            }).error(function() {
                modalDialog.alertType('请检查填写项!', '', 'warning', false);
            });
        };

        /** [cancel description] 取消操作 */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /** [cancelb description]直接取消 */
        $scope.cancelb = function() {
            $modalInstance.dismiss();
        };

        // 检查领域名或领域编码是否已存在
        function detection () {
            var deffer = $q.defer();
            var params = {
                dictName: $scope.data.dictName,
                dictNum: $scope.data.dictNum,
                fieldId: $scope.data.fieldId
            };
            $scope.loadingPromise = trsHttpService.httpServer('/api/tenantcenter/fieldhotpot/detectDictNameOrDictNum', params, 'post', '', { token: item.token }).then(function(data) {
                if (data.code === '200' && !/不可用/.test(data.msg)) {
                    console.log(data);
                    deffer.resolve();
                } else {
                    modalDialog.alertType(data.msg || '领域名或领域编码不可用', '', 'error', 'confirm');
                }
            });
            return deffer.promise;
        }
        
        /** [description]新建的操作 */
        function createHandler() {
            $scope.loadingPromise = trsHttpService.httpServer('/api/tenantcenter/fieldhotpot/updateOneHot', $scope.data, 'post', '', { token: item.token }).then(function(data) {
                if (data.code === '200') {
                    modalDialog.alertType('新建成功!', '', 'success', false);
                    $modalInstance.close('success');
                } else {
                    modalDialog.alertType('新建失败请再次尝试!', '', 'error', 'confirm');
                }
            });
        }

        /** [edit description]编辑的操作 */
        function editHandler() {
            $scope.loadingPromise = trsHttpService.httpServer('/api/tenantcenter/fieldhotpot/updateOneHot', $scope.data, 'post', '', { token: item.token }).then(function(data) {
                if (data.code === '200') {
                    modalDialog.alertType('修改成功!', '', 'success', false);
                    $modalInstance.close('success');
                } else {
                    modalDialog.alertType('修改失败请再次尝试!', '', 'error', 'confirm');
                }
            });
        }
    }]);
